import noDatapointsImage from '@/../img/placeholders/no-datapoints-placeholder.png';

export function NoDatapointsPlaceholder() {
  return (
    <img
      alt="Property overview placeholder statistics"
      css="width: 580px; padding: 40px 0px;"
      data-testid="property-overview-placeholder-statistics"
      src={noDatapointsImage}
    />
  );
}
